var map = {
	"./accounting-localization.json": 2327,
	"./app-secret-localization.json": 8055,
	"./cashier-localization.json": 7892,
	"./classification-map-localization.json": 7331,
	"./current-stationary-localization.json": 4420,
	"./department-localization.json": 9284,
	"./diagnosis-form-component-localization.json": 6512,
	"./drug-treatment-template-use-localization.json": 4885,
	"./drug-treatment-template-use-localization.json.json": 4885,
	"./duty-share-localization.json": 1465,
	"./education-localization.json": 9858,
	"./ehr-test-localization.json": 3012,
	"./el-form-localization.json": 8033,
	"./en.json": 706,
	"./error-code.json": 8178,
	"./form-permission-localization.json": 9131,
	"./group-permission-localization.json": 747,
	"./header-localization.json": 4573,
	"./history-expire-localization.json": 6401,
	"./history-localization.json": 4658,
	"./insurance-relief-upload.json": 7893,
	"./item-limit-localization.json": 4696,
	"./item-move-localization.json": 3471,
	"./ka.json": 347,
	"./kadr-localization.json": 4269,
	"./laboratory-localization.json": 8898,
	"./login-localization.json": 6834,
	"./message-template-localization.json": 1196,
	"./moh-case-pdf-localization.json": 4416,
	"./moh-product-map-localization.json": 5875,
	"./nosology-localization.json": 8272,
	"./nurse-localization.json": 5668,
	"./one-day-prescription-localization.json": 7967,
	"./organization-localization.json": 4729,
	"./paid-salary-localization.json": 8809,
	"./password-localization.json": 4673,
	"./patient-localization.json": 5358,
	"./patient-merge-localization.json": 8242,
	"./payment-localization.json": 3575,
	"./person-localization.json": 8886,
	"./position-localization.json": 4179,
	"./prescription-form-localization.json": 8768,
	"./price-localization.json": 2542,
	"./report-localization.json": 5554,
	"./research-localization.json": 5143,
	"./rs-waybill-load-localization.json": 6226,
	"./salary-block-localization.json": 926,
	"./salary-localization.json": 551,
	"./setting-localization.json": 4296,
	"./shift-localization.json": 9282,
	"./sms-localization.json": 4092,
	"./synonym-localization.json": 3657,
	"./timetable-localization.json": 7362,
	"./user-localization.json": 378,
	"./ward-localization.json": 8447,
	"./workflow-localization.json": 6815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4174;